export var TextLocationEnum;
(function (TextLocationEnum) {
    TextLocationEnum["Inside"] = "inside";
    TextLocationEnum["Outside"] = "outside";
    TextLocationEnum["Hidden"] = "hidden";
})(TextLocationEnum || (TextLocationEnum = {}));
export var FieldInputType;
(function (FieldInputType) {
    FieldInputType["Month"] = "month";
    FieldInputType["Week"] = "week";
    FieldInputType["Time"] = "time";
    FieldInputType["Password"] = "password";
    FieldInputType["Email"] = "email";
    FieldInputType["Number"] = "number";
    FieldInputType["Url"] = "url";
})(FieldInputType || (FieldInputType = {}));
export var FieldType;
(function (FieldType) {
    FieldType["Checkbox"] = "checkbox";
    FieldType["Date"] = "date";
    FieldType["Datetime"] = "datetime";
    FieldType["File"] = "file";
    FieldType["Input"] = "input";
    FieldType["Radio"] = "radio";
    FieldType["Search"] = "search";
    FieldType["Select"] = "select";
    FieldType["Textarea"] = "textarea";
})(FieldType || (FieldType = {}));
export var OperatorType = {
    Equal: 'eq',
    GreaterOrEqual: 'ge',
    LessOrEqual: 'le',
    NotSet: ''
};
